import React from "react";
import Pill from "../common/Pill";

export default function AIPlatformHero() {
  return (
    <div className="relative py-10 bg-[#111219] overflow-hidden flex items-center justify-center ">
      {/* Background Glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="w-[150px] h-[150px] bg-red-600/60 blur-[70px] rounded-full absolute right-[100px] rotate-45 top-[50px]" />
        <div className="w-[150px] h-[900px] bg-red-600/60 blur-[150px] rounded-full absolute left-[200px] -rotate-45 top-[50px]" />
      </div>

      <div className="max-w-6xl w-full relative z-10 px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <Pill text=" ai platform" backgroundColor="#FFFFFF1A" />
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl text-white font-semibold mb-4 leading-snug">
            What We're Building
          </h2>
          <p className="text-gray-400">
            Create, train, and deploy AI agents through simple QR codes.
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          {/* Card Component */}
          {[
            {
              title: "Multiple Agents",
              desc: "Create and manage several AI agents at once.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
                >
                  <path
                    fill="url(#paint0_linear_758_1292)"
                    d="M25 4.167c11.506 0 20.833 9.327 20.833 20.833S36.506 45.833 25 45.833 4.167 36.506 4.167 25 13.494 4.167 25 4.167m0 27.083a16.62 16.62 0 0 0-12.1 5.208A16.63 16.63 0 0 0 25 41.667a16.63 16.63 0 0 0 12.098-5.209A16.63 16.63 0 0 0 25 31.25m.979-20.167a1.054 1.054 0 0 0-1.958 0l-.53 1.271a9.1 9.1 0 0 1-4.687 4.848l-1.496.667a1.104 1.104 0 0 0 0 2.004l1.584.704a9.1 9.1 0 0 1 4.625 4.688l.51 1.179a1.055 1.055 0 0 0 1.946 0l.514-1.177a9.08 9.08 0 0 1 4.623-4.69l1.584-.704a1.105 1.105 0 0 0 0-2.006l-1.496-.667a9.1 9.1 0 0 1-4.69-4.844z"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_758_1292"
                      x1="24.9"
                      x2="24.9"
                      y1="55.375"
                      y2="11.345"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8B0000" stopOpacity="0.376"></stop>
                      <stop offset="0.5" stopColor="#B22222"></stop>
                      <stop offset="1" stopColor="#FF4D4D"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              ),
            },
            {
              title: "Custom Training",
              desc: "Train each agent with your own data for precise answers.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
                >
                  <path
                    fill="url(#paint0_linear_758_1338)"
                    d="M22.917 5.281a8.334 8.334 0 0 0-12.5 7.219v3.696c-1.773.712-3.228 1.82-4.29 3.281-1.352 1.86-1.96 4.138-1.96 6.565a9.37 9.37 0 0 0 4.166 7.795v2.621a9.375 9.375 0 0 0 14.583 7.796v-7.796c0-2.777-.687-4.552-1.791-5.75-1.131-1.223-2.967-2.133-5.842-2.612l.684-4.108c2.712.45 5.087 1.297 6.95 2.735zm4.166 0v21.442c1.863-1.438 4.238-2.285 6.95-2.735l.684 4.108c-2.875.479-4.71 1.39-5.842 2.614-1.104 1.196-1.792 2.971-1.792 5.748v7.796a9.375 9.375 0 0 0 14.584-7.796v-2.62a9.36 9.36 0 0 0 4.166-7.796c0-2.427-.608-4.705-1.96-6.563-1.063-1.462-2.517-2.57-4.29-3.283V12.5a8.333 8.333 0 0 0-12.5-7.219"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_758_1338"
                      x1="24.9"
                      x2="24.9"
                      y1="55.376"
                      y2="11.343"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8B0000" stopOpacity="0.376"></stop>
                      <stop offset="0.5" stopColor="#B22222"></stop>
                      <stop offset="1" stopColor="#FF4D4D"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              ),
            },
            {
              title: "No-Code Platform",
              desc: "Build and deploy AI agents for any physical space without coding.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
                >
                  <path
                    fill="url(#paint0_linear_758_1341)"
                    fillRule="evenodd"
                    d="M4.688 10.938a6.25 6.25 0 0 1 6.25-6.25h28.124a6.25 6.25 0 0 1 6.25 6.25V31.25a6.25 6.25 0 0 1-6.25 6.25h-6.25v.535c0 1.244.494 2.438 1.373 3.315l1.294 1.296a1.563 1.563 0 0 1-1.104 2.666h-18.75a1.563 1.563 0 0 1-1.104-2.666l1.294-1.296a4.7 4.7 0 0 0 1.373-3.312V37.5h-6.25a6.25 6.25 0 0 1-6.25-6.25zm3.125 0v15.625a3.125 3.125 0 0 0 3.125 3.125h28.124a3.125 3.125 0 0 0 3.126-3.125V10.938a3.125 3.125 0 0 0-3.126-3.126H10.939a3.125 3.125 0 0 0-3.126 3.125"
                    clipRule="evenodd"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_758_1341"
                      x1="24.903"
                      x2="24.903"
                      y1="54.615"
                      y2="11.686"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8B0000" stopOpacity="0.376"></stop>
                      <stop offset="0.5" stopColor="#B22222"></stop>
                      <stop offset="1" stopColor="#FF4D4D"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              ),
            },
          ].map((card, index) => (
            <div
              key={index}
              className="relative bg-black rounded-2xl p-8 backdrop-blur-sm border border-gray-700 overflow-hidden text-center flex flex-col items-center"
            >
              <div className="absolute inset-0 pointer-events-none">
                <div className="w-[200px] h-[150px] bg-yellow-700/50 blur-[50px] rounded-full absolute -right-[5px] top-0 " />
                <div className="w-[100px] h-[100px] bg-yellow-700/50 blur-[30px] rounded-full absolute left-0 -bottom-[10px]" />
              </div>

              <div className="w-14 h-14 mb-6 text-red-500 flex items-center justify-center">
                {card.icon}
              </div>
              <h3 className="text-2xl font-semibold text-white mb-3">
                {card.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {card.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom Row Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {[
            {
              title: "Instant QR",
              desc: "Generate and share QR codes instantly for each location.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
                >
                  <path
                    fill="url(#paint0_linear_758_1344)"
                    d="M19.091 3.333H7.273a3.94 3.94 0 0 0-3.94 3.94V19.09a3.94 3.94 0 0 0 3.94 3.94H19.09a3.94 3.94 0 0 0 3.94-3.94V7.273a3.94 3.94 0 0 0-3.94-3.94m0 15.758H7.273V7.273H19.09zm0 7.879H7.273a3.94 3.94 0 0 0-3.94 3.94v11.817a3.94 3.94 0 0 0 3.94 3.94H19.09a3.94 3.94 0 0 0 3.94-3.94V30.91a3.94 3.94 0 0 0-3.94-3.94m0 15.757H7.273V30.91H19.09zM42.727 3.333H30.91a3.94 3.94 0 0 0-3.94 3.94V19.09a3.94 3.94 0 0 0 3.94 3.94h11.818a3.94 3.94 0 0 0 3.94-3.94V7.273a3.94 3.94 0 0 0-3.94-3.94m0 15.758H30.91V7.273h11.818zM26.97 36.818V28.94a1.97 1.97 0 1 1 3.94 0v7.88a1.97 1.97 0 0 1-3.94 0m19.697-3.94a1.97 1.97 0 0 1-1.97 1.97h-5.909v9.849a1.97 1.97 0 0 1-1.97 1.97H28.94a1.97 1.97 0 1 1 0-3.94h5.909V28.94a1.97 1.97 0 1 1 3.939 0v1.97h5.91a1.97 1.97 0 0 1 1.969 1.97m0 7.88v3.939a1.97 1.97 0 1 1-3.94 0v-3.94a1.97 1.97 0 0 1 3.94 0"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_758_1344"
                      x1="24.896"
                      x2="24.896"
                      y1="56.59"
                      y2="10.798"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8B0000" stopOpacity="0.376"></stop>
                      <stop offset="0.5" stopColor="#B22222"></stop>
                      <stop offset="1" stopColor="#FF4D4D"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              ),
            },
            {
              title: "Real-Time",
              desc: "Update agents instantly without redeploying.",
              icon: (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="50"
                  height="50"
                  fill="none"
                  viewBox="0 0 50 50"
                >
                  <path
                    fill="url(#paint0_linear_758_1348)"
                    fillRule="evenodd"
                    d="M30.448 3.323a1.56 1.56 0 0 1 .748 1.775l-4.15 15.214h15.141a1.564 1.564 0 0 1 1.142 2.63L21.454 46.379a1.563 1.563 0 0 1-2.65-1.479l4.15-15.212H7.812a1.563 1.563 0 0 1-1.141-2.63L28.546 3.621a1.56 1.56 0 0 1 1.902-.298"
                    clipRule="evenodd"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_758_1348"
                      x1="24.91"
                      x2="24.91"
                      y1="56.895"
                      y2="10.662"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#8B0000" stopOpacity="0.376"></stop>
                      <stop offset="0.5" stopColor="#B22222"></stop>
                      <stop offset="1" stopColor="#FF4D4D"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              ),
            },
          ].map((card, index) => (
          <div
  key={index}
  className="relative bg-black rounded-2xl p-8 backdrop-blur-sm border border-gray-700 text-center flex flex-col items-center"
>
  <div className="absolute inset-0 rounded-2xl overflow-hidden pointer-events-none">
    <div className="w-[200px] h-[200px] bg-yellow-700/50 blur-[40px] rounded-full absolute left-0 -bottom-[10px]" />
    <div className="w-[100px] h-[100px] bg-yellow-700/50 blur-[30px] rounded-full absolute -right-[5px] top-0" />
  </div>

  <div className="w-14 h-14 mb-6 text-red-500 flex items-center justify-center relative z-10">
    {card.icon}
  </div>
  <h3 className="text-2xl font-semibold text-white mb-3 relative z-10">
    {card.title}
  </h3>
  <p className="text-gray-400 text-sm leading-relaxed relative z-10">
    {card.desc}
  </p>
</div>
          ))}
        </div>
      </div>
    </div>
  );
}
